import { createSlice } from "@reduxjs/toolkit";
import { api } from "../../app/applicationSlice";
import { RootState, RootThunk } from "../../app/store";
import { stockfloorPage, StockfloorParams } from "../../services/stockfloor";

const initialState = {
    StockfloorData: [],
    Total: 0,
    Current: 1
}

export const stockfloorSlice = createSlice({
    name: "stockfloor",
    initialState,
    reducers: {
        setData(state, action) {
            state.StockfloorData = action.payload
        },
        setTotal(state, action) {
            state.Total = action.payload
        },
        setCurrent(state, action) {
            state.Current = action.payload
        }
    }
})

export function pageStockfloor(
    params: StockfloorParams
): RootThunk {
    return api(stockfloorPage(params), (data: any, dispatch) => {
        dispatch(setData(data.records))
        dispatch(setTotal(data.total))
    })
}


export const { setData, setTotal, setCurrent } = stockfloorSlice.actions

export const selectStockfloorData = (state: RootState) => state.stockfloor.StockfloorData

export const selectTotal = (state: RootState) => state.stockfloor.Total

export const selectCurrent = (state: RootState) => state.stockfloor.Current

export default stockfloorSlice.reducer